import { alpha } from "@mui/material";

export const pageContainerSx = {
  minHeight: "100vh",
  bgcolor: (theme) => alpha(theme.palette.background.default, 0.5),
};

export const loadingOverlaySx = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: (theme) => alpha(theme.palette.background.default, 0.8),
  zIndex: 9999,
  backdropFilter: "blur(4px)",
};

export const spinnerRingOuterSx = {
  position: "absolute",
  width: "100%",
  height: "100%",
  borderRadius: "50%",
  border: "3px solid",
  borderColor: "divider",
  borderTopColor: "primary.main",
  animation: "spin 1s linear infinite",
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(360deg)" },
  },
};

export const spinnerRingInnerSx = {
  position: "absolute",
  width: "65%",
  height: "65%",
  top: "17.5%",
  left: "17.5%",
  borderRadius: "50%",
  border: "2px solid",
  borderColor: "divider",
  borderTopColor: "secondary.main",
  animation: "spin 0.8s linear infinite reverse",
};

export const tableContainerSx = {
  maxHeight: "calc(100vh - 160px)",
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  overflow: "auto",
  "& .MuiTable-root": {
    minWidth: 650,
  },
};

export const centeredColSx = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1.5,
};
